import React from 'react';
import PropTypes from 'prop-types';
import { DetailPanelData } from "../Common/DetailPanel";
import { formatSQLDateTime } from '../../utils';
import { renderWeight } from '../../Utils/weight_utils';

const CylinderHeaders = ({
    isSystemAdministrator = false,
    data: {
        isCylinder = false,
        materialTypeName = '',
        materialStatusName = '',
        currentGasWeightLBS = '',
        maxGasCapacity = '',
        cylinderGWP = '',
        dotExpirationDate = '',
        psiRatingName = '',
        currentPSI = '',
        boughtRented = null,
        vendorSupplier = '',
        safetyClassName = null,
    } = {}
}) => {
    if (!isCylinder) return null;
    let boughtOrRented = '';

    if (boughtRented === 2) boughtOrRented = 'Rented';

    if (boughtRented === 1) boughtOrRented = 'Bought';
    return (
        <>
            <DetailPanelData id='MaterialStatusHeader' title="MATERIAL STATUS" data={materialStatusName}  />
            <DetailPanelData
                id='CurrentGasWeightHeader'
                title="CURRENT GAS WEIGHT"
                data={renderWeight(currentGasWeightLBS)}
                 
            />
            <DetailPanelData id='MaxGasCapacityHeader' title="MAX GAS CAPACITY" data={renderWeight(maxGasCapacity)}  />
            <DetailPanelData id='SystemGWPHeader' title="SYSTEM GWP" data={`${cylinderGWP}`}  />
            <DetailPanelData id='DotExpirationHeader' title="DOT EXPIRATION DATE" data={formatSQLDateTime(dotExpirationDate)}  />
            <DetailPanelData id='PSIRatingHeader' title="PSI RATING" data={psiRatingName}  />
            <DetailPanelData id='CurrentPSIHeader' title="CURRENT PSI" data={currentPSI}  />
            {/* //props.model.InstanceID == 1083 BELOW  */}
            <DetailPanelData id='BoughtRentedHeader' title="BOUGHT/RENTED" data={boughtOrRented}  />
            <DetailPanelData id='VendorSupplierHeader' title="VENDOR/SUPPLIER" data={vendorSupplier}  />
            <DetailPanelData id='safetyClass' title="SAFETY CLASS" data={safetyClassName}  />
        </>
    );
};

CylinderHeaders.propTypes = {
    data: PropTypes.object.isRequired
};

export default CylinderHeaders;
